export default __webpack_public_path__ + "static/media/learose4-1024w.37ed5a8c.webp";